<template>
    <div>
        <div v-if="downloadFlag" class="mb5 mr">
            <el-button class="swb-btn swb-btn-primary" @click="download()">下载</el-button>
        </div>
        <div v-if="typeId == 302">
            <el-table :data="servicerServcProcessProduct" ref="deviceImpInfoTable" border>
                <el-table-column prop="shopName" label="门店" align="left"></el-table-column>
                <el-table-column prop="period" label="时段" width="150" align="center"></el-table-column>
                <el-table-column prop="shoudScanQuantity" label="应扫数量" width="100" align="right">
                    <template slot-scope="rows">
                        <span>{{rows.row.shoudScanQuantity || 0}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="actualScanQuantity" label="实扫数量" width="100" align="right">
                    <template slot-scope="rows">
                        <span>{{rows.row.actualScanQuantity || 0}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="notScanQuantity" label="未扫数量" width="100" align="right">
                    <template slot-scope="rows">
                        <span>{{rows.row.notScanQuantity || 0}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-else>
            <el-table :data="servicerServcProcessProduct" ref="deviceImpInfoTable" border>
                <el-table-column prop="groupName" label="分组名称" align="left" width="100"></el-table-column>
                <el-table-column prop="servicerName" label="服务商" align="left"></el-table-column>
                <el-table-column prop="repairQuantity" :label="typeId == 301? '保养数量':'报修数量'" width="100" align="right">
                    <template slot-scope="rows">
                        <span>{{rows.row.repairQuantity || 0}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="readyStartQuantity" label="未出发数量" width="100" align="right">
                    <template slot-scope="rows">
                        <span>{{rows.row.readyStartQuantity || 0}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="readyArrivedQuantity" label="未到达数量" width="100" align="right">
                    <template slot-scope="rows">
                        <span>{{rows.row.readyArrivedQuantity || 0}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="inServiceQuantity" label="服务中数量" width="100" align="right">
                    <template slot-scope="rows">
                        <span>{{rows.row.inServiceQuantity || 0}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failed" label="服务暂停数量" width="100" align="right">
                    <template slot-scope="rows">
                        <span>{{rows.row.serveInterruptQuantity || 0}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failed" label="未验收数量" width="100" align="right">
                    <template slot-scope="rows">
                        <span>{{rows.row.completedQuantity || 0}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { showGrpDownloadDlg } from '../ctrl/dialog'

    import merchtAllApi from '../../api/merchtAll'
    import ElButton from '../../../node_modules/element-ui/packages/button/src/button';

    export default {
        components: {ElButton}, name: 'swb-mercht-report-snapshot-view',
        path: '/mercht/report/snapshot/view',
        desc: '商户报表快照-预览',
        props: ["snapshotId", "typeId", "downloadFlag"],
        data: function () {
            return {
                servicerServcProcessProduct: [],
            }
        },
        created: function () {
            let snapshotId = this.snapshotId || null;
            if(!Utils.isNoB(snapshotId)) {
                this.getDataList(snapshotId);
            } else {
                MsgBox.warning("参数异常！")
            }
        },
        methods: {
            getDataList(snapshotId){
                let self = this;
                let theLoading = MsgBox.loading();
                let postData = {
                    snapshotId: snapshotId
                };
                merchtAllApi.getMerchtReportSnapshotJsonById(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        console.log(result.data);
                        //
                        self.servicerServcProcessProduct = Utils.merge([], result.data.rows);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            download: function () {
                let self = this;
                let downloadUrls = [];
                let tmpFile = {};
                tmpFile.url = getAppUrl("/file/export/as/excel");
                tmpFile.post = true;
                tmpFile.fileName = "报表快照";
                //
                let tableData = this.getTableData();
                //
                let data = Utils.merge({}, tableData);
                data.fileName = tmpFile.fileName;
                tmpFile.data = data;
                downloadUrls.push(tmpFile);
                let title = '报表快照-下载';
                showGrpDownloadDlg(title, downloadUrls);
            },
            getTableData(){
                let exportCols = this.makeTableCols();
                let tableData = {};
                tableData.cols = JSON.decode(exportCols);
                //
                let rowsSrc = {};
                rowsSrc.data = {
                    snapshotId: this.snapshotId,
                    exportFlag: true
                };
                rowsSrc.url = "/merchtAll/mercht/report/snapshot/json/get";
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageNumber = 1;

                return tableData;
            },
            makeTableCols: function () {
                let exportCols = '[{"name":"groupName","title":"分组名称","width":150,"dataType":"string","align":"left","overflowAsTip":false,"format":null,"asTpl":false},{"name":"servicerName","title":"服务商","width":350,"dataType":"string","align":"center","overflowAsTip":false,"format":null,"asTpl":false},{"name":"repairQuantity","title":"报修数量","width":350,"dataType":"integer","align":"center","overflowAsTip":false,"format":null,"asTpl":false},{"name":"readyStartQuantity","title":"未出发数量","dataType":"integer","width":100,"align":"left","overflowAsTip":false,"format":null,"asTpl":false},{"name":"readyArrivedQuantity","title":"未到达数量","width":130,"dataType":"integer","align":"left","overflowAsTip":false,"format":null,"asTpl":false},{"name":"inServiceQuantity","title":"服务中数量","width":200,"dataType":"integer","align":"left","overflowAsTip":false,"format":null,"asTpl":false},{"name":"serveInterruptQuantity","title":"服务暂停数量","dataType":"integer","width":120,"align":"left","overflowAsTip":false,"format":null,"asTpl":false},{"name":"completedQuantity","title":"未验收数量","width":120,"dataType":"integer","align":"left","overflowAsTip":false,"format":null,"asTpl":false}]'; //
                if(this.typeId == 302) {
                    // 扫码抄温
                    exportCols = '[{"name":"shopName","title":"门店","width":150,"dataType":"string","align":"left","overflowAsTip":false,"format":null,"asTpl":false},{"name":"period","title":"时段","width":350,"dataType":"string","align":"center","overflowAsTip":false,"format":null,"asTpl":false},{"name":"shoudScanQuantity","title":"应扫数量","width":350,"dataType":"integer","align":"center","overflowAsTip":false,"format":null,"asTpl":false},{"name":"actualScanQuantity","title":"实扫数量","dataType":"integer","width":100,"align":"left","overflowAsTip":false,"format":null,"asTpl":false},{"name":"notScanQuantity","title":"未扫数量","width":130,"dataType":"integer","align":"left","overflowAsTip":false,"format":null,"asTpl":false}]';
                }
                return exportCols;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/easyReport/MerchtReportSnapshotView.vue